import { SET_MESSAGE, CLEAR_MESSAGE } from "./types";
import RestService from "../services/rest.service";
import { useSelector } from "react-redux";
// export const setMessage = (message) => ({
//   type: SET_MESSAGE,
//   payload: message,
// });
//
// export const clearMessage = () => ({
//   type: CLEAR_MESSAGE,
// });
//
// export const clearMessage = () => ({
//   type: CLEAR_MESSAGE,
// });
export const fetchStartParam = (site = "iamconsulting", direct = false) => async (dispatch) => {
  const IP_DEFAULT = '127.0.0.1';

  let ip = localStorage.getItem("ip"); //'127.0.0.1';
  if (!ip) ip = IP_DEFAULT

  if (!ip || ip === IP_DEFAULT) {

    try {
      let response = await fetch('https://www.cloudflare.com/cdn-cgi/trace')
      if (response) {
        const data = await response.text()
        data.trim().split('\n').map(info => {
          if (info.indexOf('=') !== -1) {
            const [field, value] = info.split('=')
            if (field.toLowerCase() === 'ip') ip = value
          }
        })
      }
    } catch (error) { }
  }

  if (!ip || ip === IP_DEFAULT) {
    try {
      const response = await fetch('https://ipapi.co/json/')
      const data = await response.json()
      if (data.ip) ip = data.ip
    } catch (error) { }
  }

  localStorage.setItem("ip", ip)

  let url_site = `site/${site}`
  if (direct) url_site += '?direct=true'

  return RestService.get(url_site).then(
    (response) => {

      if (response?.data?.data?.client?.logo !== undefined && response?.data?.data?.client?.logo !== null) {
        localStorage.setItem("logo", response?.data?.data?.client?.logo);
      }
      // mapping data
      dispatch({
        type: "SET_START_PARAM",
        payload: response.data,
      });


      if (response.data.data.configuration?.redirect_url) {
        window.location(response.data.data.configuration.redirect_url)
      }
      if (response.data?.data?.recaptcha?.key ?? false) {
        dispatch({
          type: "SET_RECAPTCHA_KEY",
          payload: response.data.data.recaptcha.key,
        });
      } else {
        return Promise.reject("Couldn't load Recaptcha configuration.");
      }
      return Promise.resolve(response.data);
    },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      dispatch({
        type: "REGISTER_FAIL",
      });
      dispatch({
        type: "SET_MESSAGE",
        payload: message,
      });
      return Promise.reject();
    }
  );
};
export const getStartParam = () => async (dispatch) => {
  const Start = useSelector((state) => state.Start);
  if (Start === []) {
    await fetchStartParam("iamconsulting")
  }
  return Start;
};
export const updateStartParam = (data) => (dispatch) => {
  return dispatch({
    type: "SET_CARRY_SCORE",
    payload: data,
  })
};
// export const saveCarryScore = (data) => (dispatch) => {
//
//     return RestService.post('Planning_CarryScore').then(
//         (response) => {
//             // mapping data
//             dispatch({
//                 type: "SET_CARRY_SCORE",
//                 payload: response.data,
//             });
//             return Promise.resolve(response.data);
//         },
//         (error) => {
//             const message =
//                 (error.response &&
//                     error.response.data &&
//                     error.response.data.message) ||
//                 error.message ||
//                 error.toString();
//             dispatch({
//                 type: "REGISTER_FAIL",
//             });
//             dispatch({
//                 type: "SET_MESSAGE",
//                 payload: message,
//             });
//             return Promise.reject();
//         }
//     );
// };

export const verifyRecaptcha = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    let reqBody = {
      response: data,
    }
    RestService.post(`app/recaptcha`, reqBody).then(
      (response) => {
        resolve(response)
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    );
  })
};

export const getSsoLogin = (data) => (dispatch) => {
  return RestService.get('app/login/sso').then((response) => {
    return Promise.resolve(response.data);
  },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      dispatch({
        type: "SET_MESSAGE",
        payload: message,
      });
      return Promise.reject();
    })


  return new Promise((resolve, reject) => {
    let reqBody = {
      response: data,
    }
    RestService.get(`app/login/sso`, reqBody).then(
      (response) => {
        resolve(response.data)
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    );
  })
};

export const postSsoLoginCallback = (data) => (dispatch) => {
  let reqBody = {
    code: data.code,
    state: data.state,
  }


  return RestService.post('app/login/sso/callback', reqBody).then((response) => {
    let respData = response?.data?.data ?? false
    if (respData) {
      localStorage.setItem("user", JSON.stringify(respData));
      dispatch({
        type: "LOGIN_SUCCESS",
        payload: { user: response },
      });
    }
    return Promise.resolve(respData)
  },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      dispatch({
        type: "SET_MESSAGE",
        payload: message,
      });
      return Promise.reject();
    })



  return new Promise((resolve, reject) => {
    let reqBody = {
      code: data.code,
      state: data.state,
    }
    RestService.post(`app/login/sso/callback`, reqBody).then(
      (response) => {
        let respData = response?.data?.data ?? false
        if (respData) {
          localStorage.setItem("user", JSON.stringify(respData));
          dispatch({
            type: "LOGIN_SUCCESS",
            payload: { user: response },
          });
        }
        resolve(respData)
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    );
  })
};